import { Outlet } from 'react-router-dom';

export function WithLibraryPage() {
  return <Outlet />;
}
